import { render, staticRenderFns } from "./sixPage.vue?vue&type=template&id=56ff0802&"
import script from "./sixPage.vue?vue&type=script&lang=js&"
export * from "./sixPage.vue?vue&type=script&lang=js&"
import style0 from "./sixPage.vue?vue&type=style&index=0&id=56ff0802&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports